interface CheckedCircleIconProps {
  className?: string;
}

export default function CheckedCircleIcon({
  className,
}: CheckedCircleIconProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="CheckedCircleIcon"
        d="M12.2817 21.4111C11.8833 21.4111 11.543 21.234 11.2607 20.8799L6.96094 15.501C6.85579 15.3737 6.77832 15.2492 6.72852 15.1274C6.68424 15.0057 6.66211 14.8812 6.66211 14.7539C6.66211 14.4661 6.75618 14.2282 6.94434 14.04C7.13802 13.8519 7.38151 13.7578 7.6748 13.7578C8.01237 13.7578 8.29736 13.91 8.52979 14.2144L12.2485 18.9873L19.4536 7.54053C19.5809 7.34684 19.7109 7.21126 19.8438 7.13379C19.9766 7.05078 20.1481 7.00928 20.3584 7.00928C20.6462 7.00928 20.8813 7.10059 21.064 7.2832C21.2466 7.46029 21.3379 7.69271 21.3379 7.98047C21.3379 8.09668 21.3185 8.21566 21.2798 8.3374C21.241 8.45361 21.1802 8.57812 21.0972 8.71094L13.2944 20.8716C13.0509 21.2313 12.7134 21.4111 12.2817 21.4111Z"
        fill="currentColor"
      />
    </svg>
  );
}
